import {
  Box,
  Flex,
  Skeleton,
  SkeletonText,
  SkeletonCircle,
  Card,
  CardHeader,
} from '@chakra-ui/react';

export interface CompositeIndexChartSkeletonProps {
  useCard?: boolean;
  showTitle?: boolean;
  showFilters?: boolean;
  showMetricCard?: boolean;
  showLastCalculationDate?: boolean;
}

export default function CompositeIndexChartSkeleton({
  useCard = false,
  showTitle = true,
  showFilters = true,
  showMetricCard = true,
  showLastCalculationDate = false,
}: CompositeIndexChartSkeletonProps) {
  // Chart height matches IndexChartCore logic: 400px if filters shown, otherwise 300px
  const chartHeight = showFilters ? 400 : 300;

  const headerContent = (
    <Flex direction="column" width="100%" gap={2}>
      {showTitle && (
        <SkeletonText noOfLines={1} width="30%" skeletonHeight="24px" />
      )}

      {showMetricCard && (
        <Flex alignItems="center" gap={4}>
          <SkeletonCircle size="32px" />
          <SkeletonText noOfLines={1} width="80px" skeletonHeight="22px" />
          <SkeletonText noOfLines={1} width="60px" skeletonHeight="18px" />
        </Flex>
      )}

      {showLastCalculationDate && (
        <SkeletonText noOfLines={1} width="40%" skeletonHeight="14px" />
      )}
    </Flex>
  );

  return useCard ? (
    <Card padding={4} borderRadius="lg" width="100%">
      <CardHeader paddingBottom={0}>{headerContent}</CardHeader>
      <Box mt={4}>
        {showFilters && (
          <Flex gap={1} mb={4}>
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton
                key={i}
                height="32px"
                width="60px"
                borderRadius="md"
              />
            ))}
          </Flex>
        )}
        <Skeleton height={`${chartHeight}px`} width="100%" borderRadius="md" />
      </Box>
    </Card>
  ) : (
    <Box width="100%">
      {headerContent}
      <Box mt={4}>
        {showFilters && (
          <Flex gap={1} mb={4}>
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton
                key={i}
                height="32px"
                width="60px"
                borderRadius="md"
              />
            ))}
          </Flex>
        )}
        <Skeleton height={`${chartHeight}px`} width="100%" borderRadius="md" />
      </Box>
    </Box>
  );
}